module.exports = __webpack_public_path__ + "assets/img/kv-d55cf641.jpg";